import { NavigationDrawerItemProps } from 'components/navigation_drawer/NavigationDrawerItem';
import { SecondaryNavigationItems } from 'components/navigation_drawer/SecondaryNavigationItems';
import { NavigationItemTitle } from 'components/navigation_drawer/styled';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import * as React from 'react';

export type SecondaryNavigationPopupProps<TTriggerElem extends HTMLElement> = Readonly<{
    parentId: string;
    title: string;
    popupRef: React.RefObject<HTMLDivElement>;
    triggerRef: React.RefObject<TTriggerElem>;
    activeStyle: React.CSSProperties;
    secondaryNavigationItems: NavigationDrawerItemProps[] | undefined;
    onClose: () => void;
}>;

export function SecondaryNavigationPopup<TTriggerElem extends HTMLElement>({
    parentId,
    title,
    popupRef,
    triggerRef,
    activeStyle,
    secondaryNavigationItems,
    onClose,
}: SecondaryNavigationPopupProps<TTriggerElem>) {
    return (
        <StatelessPopup
            noPadding
            noOverlay
            popupClassName="navigation-popup"
            ref={popupRef}
            anchor={triggerRef.current}
            anchorAlign={{ horizontal: 'right', vertical: 'top' }}
            popupSettings={{
                borderRadius: '0 5px 5px 0',
                style: { boxShadow: 'none', width: '25rem', border: 'none' },
            }}
            onClose={onClose}
        >
            <NavigationItemTitle $secondary style={activeStyle}>
                {title}
            </NavigationItemTitle>
            <SecondaryNavigationItems
                parentId={parentId}
                show
                fitToScreenHeight
                items={secondaryNavigationItems}
            />
        </StatelessPopup>
    );
}
